import React from "react";
import { useSpring, animated } from "@react-spring/web";
import { useInView } from "react-intersection-observer";

export default function AboutUs() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.25 });
  const { number } = useSpring({
    from: { number: 0 },
    to: { number: inView ? 20 : 0 },
    config: { duration: 1200 },
    pause: !inView,
  });

  return (
    <section id="about" className="bg-background-primary py-16 min-h-screen md:h-3/2 lg:h-1/2 flex items-center justify-center">
    
      <div className="  container mx-auto flex flex-col md:flex-row items-center justify-between px-4 md:px-8 lg:px-12">
        {/* Left Half - Images */}
        <div className="relative w-full md:w-1/2 mb-8 md:mb-0 flex flex-col items-start justify-center">
          <img
            src="https://img.freepik.com/premium-photo/automatic-line-production-plastic-bags_155027-3134.jpg?ga=GA1.1.1759853381.1723916631&semt=ais_hybrid" // Replace with your medium-sized image URL
            alt="About Us"
            className="rounded-md w-2/4 h-auto max-h-[400px] object-cover"
          />
          <img
            src="https://img.freepik.com/premium-photo/clear-plastic-film-rolls-warehouse-production-transparent-plastic-sheets-packaging-product-display-factory-plant_969100-7593.jpg?ga=GA1.1.1759853381.1723916631&semt=ais_hybrid" // Replace with your overlay image URL
            alt="Overlay"
            className="absolute bottom-5 right-5 w-2/5 h-auto max-h-[250px] object-cover rounded-md shadow-lg transform translate-x-0 translate-y-1/4"
          />
        </div>

        {/* Right Half - Text Content */}
        <div className="w-full md:w-1/2 text-left md:pl-8">
          <h3 className="text-text-primary text-lg font-semibold mb-2">About Us</h3>
          <h2 className="text-3xl font-bold mb-4 text-primary">
            Manufacturer of <br />
            Versatile Poly Bags
          </h2>
          <p className="text-text-primary mb-6 max-w-[560px]">
          Established in 2000, K-PACK has grown into one of Pakistan’s premier packaging solution providers, specializing in high-quality<strong> LDPE</strong> and<strong> HDPE</strong>  products. With a focus on innovation, quality, and sustainability, we manufacture a wide range of recycled and non-recycled bags, reels, and industrial shrink films. Our offerings cater to diverse industries, including food and non-food sectors, with both printed and unprinted options tailored to meet your specific needs. 
Our commitment to excellence is reflected in the certifications we hold, including <strong>HALAL</strong>, <strong>ISO</strong>, and <strong>Global Recycle Standard (GRS)</strong>. These accolades not only validate our product safety and quality but also underscore our dedication to sustainability and ethical practices. 
At K-PACK, we take pride in our ability to adapt to changing market demands while delivering consistent value to our customers. With state-of-the-art manufacturing capabilities and a customer-centric approach, we strive to provide packaging solutions that are both functional and environmentally responsible. 
Driven by innovation and guided by integrity, we aim to build lasting partnerships with our clients, contributing to their success and the betterment of our planet. 
<br/>
<strong>K-PACK PVT LTD : Packaging the Future with Excellence.</strong>
          </p>

          {/* 20+ Years of Experience */}
          <div ref={ref} className="flex items-center">
            <animated.span className="text-4xl font-bold text-background-secondary">
              {number.to((val) => `${Math.floor(val)}+`)}
            </animated.span>
            <div className="mx-4 border-l-2 border-text-secondary h-full"></div>
            <div className="text-text-primary text-lg font-medium">
              <span>Years of</span>
              <br />
              <span className="font-bold">Industry Expertise</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
